import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface ZendeskState {
  unreadCount: number
}

export const initialState: ZendeskState = {
  unreadCount: 0,
}

const { actions, reducer } = createSlice({
  name: 'zendesk',
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload
    },
  },
})

export const zendeskActions = actions
export default reducer
